import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../hooks/reduxHooks";
import {
  getDesignInfoByUniqueId,
  getUserInfo,
  saveDesign,
} from "../../../api/save-design.api";
import { useParams, useSearchParams } from "react-router-dom";
import { generateDesignData } from "../../../store/slices/viewSlice";
import { toast } from "react-toastify"; // Import toast components
import Cookies from "js-cookie";

declare global {
  interface Window {
    design_canvas: any;
  }
}

const SaveDesign = ({
  isLoggedIn,
  onSaveDesign,
  isSaving,
  closePopup,
}: any) => {
  const { productId, designId } = useParams();

  const dispatch = useAppDispatch();
  const selectedPrintMethod = useAppSelector(
    (state) => state.canvases.selectedPrintMethod
  );
  const params = useParams();
  const [searchParams] = useSearchParams();

  const userId = searchParams.get("userId");
  const emailReceived = searchParams.get("email");
  const handle = searchParams.get("handle");
  const [email, setEmail] = useState("");
  const [designName, setDesignName] = useState("");
  const [designError, setDesignError] = useState("");

  const [emailError, setEmailError] = useState("");
  const [designNameError, setDesignNameError] = useState("");
  const [loading, setLoading] = useState(false); // State to track saving process
  const [designInfoLoading, setDesignInfoLoading] = useState(false);
  const [saveNewDesign, setSaveNewDesign] = useState(true);
  const [designInfo, setDesignInfo] = useState<any>(null);

  useEffect(() => {
    if (userId) {
      // Fetch user info if userId is available
      getUserInfo(userId).then((response) => {
        debugger;
        setEmail(response ? response.email : "");
      });
    }

    // setEmail(emailReceived ? emailReceived : "");
  }, []);
  useEffect(() => {
    if (designId) {
      setSaveNewDesign(false);
      setDesignInfoLoading(true);
      getDesignInfoByUniqueId(designId).then((res: any) => {
        setDesignInfo(res);
        setEmail(res.userEmail);
        debugger;
        setDesignName(res.designName);
        console.log(res);
        setDesignInfoLoading(false);
      });
    } else {
      setSaveNewDesign(true);
    }
  }, [designId]);

  useEffect(() => {
    if (!saveNewDesign && designInfo) {
      setDesignName(designInfo.designName);
      setEmail(designInfo.userEmail);
    }
  }, [saveNewDesign, designInfo]);

  function removeLineObjectFromAll(jsonData: any) {
    for (const key in jsonData) {
      if (
        jsonData.hasOwnProperty(key) &&
        jsonData[key].json &&
        jsonData[key].json.objects
      ) {
        // Filter out objects with type "line"
        jsonData[key].json.objects = jsonData[key].json.objects.filter(
          (obj: any) => obj.type !== "line"
        );
      }
    }

    // Return the modified JSON
    return jsonData;
  }

  function convertObjectToArray(inputObject: any) {
    return Object.keys(inputObject).map((key, index) => {
      const obj = inputObject[key];
      return {
        onlyDesignImage: obj.design_image.split(",")[1], // Extracts base64 part of the image URL - Updated
        designImage: obj.image_url.split(",")[1], // Extracts base64 part of the image URL
        designJson: JSON.stringify(obj.json), // Converts the JSON to string format
        viewId: key, // Using the object's key as viewId
        designSvg: btoa(obj.svg), // SVG data
        printMethodId: selectedPrintMethod, // Default printMethodId
      };
    });
  }

  function generateUniqueDesignNumber(prefix: string = "DESIGN"): string {
    const timestamp = Date.now();
    const randomNumber = Math.floor(Math.random() * 10000);
    const uniqueDesignNumber = `${prefix}-${timestamp}-${randomNumber}`;
    return saveNewDesign
      ? uniqueDesignNumber
      : designId
      ? designId
      : uniqueDesignNumber;
  }

  const handleSaveDesign = () => {
    let isValid = true;

    setEmailError("");
    setDesignNameError("");

    // Validate email if the user is not logged in
    if (!isLoggedIn && email && email.trim() === "") {
      setEmailError("Email is required.");
      isValid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setEmailError("Please enter a valid email address.");
      isValid = false;
    }

    if (designName === "") {
      setDesignNameError("Design name is required.");
      isValid = false;
    }

    if (isValid) {
      setLoading(true);

      dispatch(generateDesignData({}))
        .unwrap()
        .then((data: any) => {
          const modifiedData = removeLineObjectFromAll(data);

          //check design data is available or not in modified data if available then only save design else tost message
          /**{
           *  key:{
           *    json: { * },
           * }
           * }
           * 


           */
          if (
            Object.keys(modifiedData).length &&
            modifiedData[Object.keys(modifiedData)[0]].json.objects.length === 0
          ) {
            setDesignError("No design data available to save.");
            toast.error("No design data available to save.");
            setLoading(false);
            return;
          } else {
            setDesignError("");
          }

          if (!params.productId) return;

          saveDesign(params.productId, {
            sku: handle ? handle : "sku",
            user_details: {
              email: email,
              ecom_id: userId
                ? userId
                : Cookies.get("User_Session_ID")
                ? Cookies.get("User_Session_ID")
                : "ecom_id_missing",
            },
            unique_id: saveNewDesign ? generateUniqueDesignNumber() : designId,
            is_replace: false,
            design_name: designName,
            design_views: convertObjectToArray(modifiedData),
            design_edit_url_href:
              window.location.protocol +
              "//" +
              window.location.host +
              "/product-catalog/" +
              productId +
              "/edit-designing",
          } as any)
            .then((response) => {
              setLoading(false);
              onSaveDesign(response); // Call the callback
              toast.success(`Design "${designName}" saved successfully!`); // Success message
            })
            .catch((error) => {
              setLoading(false);
              toast.error("Failed to save the design. Please try again."); // Error message
              console.error("Error saving design:", error);
            });

          console.log("data_____", data, modifiedData);
        })
        .catch((error) => {
          setLoading(false);
          toast.error("Failed to generate design data. Please try again."); // Error on generating data
          console.error("Error generating design data:", error);
        });
    }
  };

  return (
    <div className="text-center px-5">
      <button
        className="absolute top-4 right-4"
        onClick={() => closePopup(false)}
      ></button>
      <div className="text-xl md:text-2xl lg:text-2xl font-bold mb-2">
        Save Your Design for Order
      </div>
      {saveNewDesign && (
        <div className="text-grey mb-5">
          Once saved, share with others and access it from anywhere!
        </div>
      )}
      {designId && !saveNewDesign && (
        <div className="text-grey mb-5">
          We found an existing design with the same name and email address
        </div>
      )}
      {designError && (
        <div className="text-red-500 text-sm mb-3">{designError}</div>
      )}
      {designId && (
        <div className="my-4 justify-center items-center">
          <div
            style={{
              display: "inline-block",
            }}
          >
            <div
              className=" justify-center items-center"
              style={{
                display: "block",
                textAlign: "left",
              }}
            >
              <input
                id="saveNewDesignFor"
                type="radio"
                name="saveDesign"
                checked={saveNewDesign}
                onChange={() => setSaveNewDesign(true)}
              />
              <label
                htmlFor="saveNewDesignFor"
                className="text-base pl-1 font-medium"
              >
                Save as new design
              </label>
            </div>

            <div
              className="flex justify-center items-center"
              style={{
                display: "block",
                textAlign: "left",
              }}
            >
              <input
                id="saveExistingDesign"
                type="radio"
                name="saveDesign"
                checked={!saveNewDesign}
                onChange={() => setSaveNewDesign(false)}
              />
              <label
                htmlFor="saveExistingDesign"
                className="text-base pl-1 font-medium"
              >
                Update Design{" "}
              </label>
            </div>
          </div>
        </div>
      )}

      {saveNewDesign && (
        <div className="my-4">
          {!isLoggedIn && (
            <div>
              <input
                defaultValue={email}
                onChange={(e) => setEmail(e.target.value)}
                className={`border border-solid border-[#939393] block mx-auto w-full max-w-[440px] p-2 rounded-md mb-3 ${
                  emailError ? "border-red-500" : ""
                }`}
                type="email"
                placeholder="Enter your Email Address for your Account..."
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
              />
              {emailError && (
                <div className="text-red-500 text-sm mb-3">{emailError}</div>
              )}
            </div>
          )}
          <div>
            <input
              onChange={(e) => setDesignName(e.target.value)}
              className={`border border-solid border-[#939393] block mx-auto w-full max-w-[440px] p-2 rounded-md mb-3 ${
                designNameError ? "border-red-500" : ""
              }`}
              type="text"
              placeholder="Enter Your Design Name Here...."
              maxLength={25}
            />
            {designNameError && (
              <div className="text-red-500 text-sm mb-3">{designNameError}</div>
            )}
          </div>
          <div className="text-xs text-grey italic">
            25 characters max, no symbols except dashes
          </div>
        </div>
      )}
      <button
        disabled={isSaving || loading || designInfoLoading}
        onClick={handleSaveDesign}
        className={`max-sm:w-full w-[80%] text-center block ${
          isSaving || loading ? "bg-gray-500" : "bg-primaryred"
        } text-white font-bold text-sm md:text-lg lg:text-lg py-2 px-7 rounded-full mx-auto my-4`}
      >
        {loading
          ? designId
            ? "Updating..."
            : "Saving..."
          : designId
          ? "Save Design & Add to Cart 👉🏻"
          : "Save Design & Add to Cart 👉🏻"}
      </button>
      <div className="text-grey">
        Your email is safe and secure. Read our{" "}
        <a href="#" className="text-blueselected underline">
          privacy policy
        </a>
      </div>
    </div>
  );
};

export default SaveDesign;
